<template>
  <div>
    <a-spin :spinning="loading">
      <a-table
        v-if="data.length > 0"
        :columns="columns"
        :data-source="data"
        :pagination="false"
        :row-key="record => record.id"
        size="middle"
      >
        <span slot="action" slot-scope="text, record">
          <a
            v-if="record.can_cancel"
            href="javascript:;"
            @click="confirmCancel(record)"
          >取消任务</a>
          <span v-else>-</span>
        </span>
      </a-table>
      <a-empty v-else />
      <pagination
        v-show="pagination.total_count > 0"
        :total-count="pagination.total_count"
        :page.sync="query.page"
        :per-page.sync="query.per_page"
        @change="fetchData"
      />
    </a-spin>
  </div>
</template>

<script>
import { findSimCardScheduledTasks, cancelSimCardScheduledTask } from '@/api/sim_card_scheduled_task'
import Pagination from '@/components/Pagination/index'

export default {
  name: 'ShowSimCardScheduledTasks',
  components: { Pagination },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      data: [],
      pagination: {
        total_count: 0
      },
      query: {
        page: 1,
        per_page: 10
      },
      columns: [
        { title: '任务类型', dataIndex: 'task_type' },
        { title: '执行时间', dataIndex: 'scheduled_execute_at' },
        { title: '状态', dataIndex: 'status' },
        { title: '创建时间', dataIndex: 'created_at' },
        { title: '操作人', dataIndex: 'operator_name' },
        { title: '批次号', dataIndex: 'operation_no' },
        { title: '备注', dataIndex: 'remark', ellipsis: true },
        { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }}
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      const params = Object.assign({ card_id: this.id }, this.query)
      findSimCardScheduledTasks(params).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination.total_count = res.pagination.total_count
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    confirmCancel(record) {
      const vm = this
      this.$confirm({
        title: '确认取消该定时断网任务？',
        content: '',
        okText: '确定',
        okType: 'danger',
        cancelText: '关闭',
        zIndex: 3000,
        onOk() {
          return vm.handleCancel(record)
        }
      })
    },

    handleCancel(record) {
      return cancelSimCardScheduledTask(record.id).then((res) => {
        if (res.code === 0) {
          this.$message.success('已取消')
          this.fetchData()
          return
        }
        this.$message.error((res.message && res.message.content) || res.message || '取消失败')
        return Promise.reject(new Error('cancel failed'))
      })
    }
  }
}
</script>
